import React from 'react';
import s from './WidgetNavMenu.scss';
import { withTranslation, WithTranslation } from 'react-i18next';
import ArrowDownIcon from '@wix/da-shared-react/pkg/Icons/ArrowDown';

export interface Props {
  className?: string;
  widgetMenuItemsList: {
    transKey: string;
    hash: string;
  }[];
}

export class WidgetNavMenu extends React.Component<Props & WithTranslation> {
  selectElementRef: any;

  render() {
    const { widgetMenuItemsList, t } = this.props;
    return (
      <div className={s['widget-dropdown-menu']}>
        <span className={s['open-menu-button']}>
          <ArrowDownIcon />
        </span>
        <select ref={this.saveSelectRef} onChange={this.navigateToHash}>
          {widgetMenuItemsList &&
            widgetMenuItemsList.map((item, key) => {
              return (
                <option key={key} value={key}>
                  {t(item.transKey)}
                </option>
              );
            })}
        </select>
      </div>
    );
  }

  saveSelectRef = ref => {
    this.selectElementRef = ref;
  };

  navigateToHash = value => {
    const { widgetMenuItemsList: menu } = this.props;
    const selectedItem = menu && menu[Number(this.selectElementRef.value)];
    const hash = selectedItem.hash;
    if (hash && document.location) {
      document.location.hash = hash;
    }
    this.selectElementRef.value = '';
  };
}

export default withTranslation()(WidgetNavMenu);
